import useTranslations from "@/components/ProductDetail/v3/ProductDetailView/ProductDescription/Feedback/localization"
import { addAnalyticsProvideFeedback } from "@/components/ProductDetail/v3//ProductDetailView/ProductDescription/Feedback/analytics"
import Style from "@/components/ProductDetail/v3/ProductDetailView/ProductDescription/Feedback/index.module.scss"

const Feedback = props => {
  const { pdpJson: { feedbackButtonLabel = "", feedbackFormID = "" } = {} } =
    props || {}

  const { feedBackTitle = "" } = useTranslations()

  const showFeedbackForm = () => {
    if (window.KAMPYLE_ONSITE_SDK) {
      if (feedbackFormID) {
        window.KAMPYLE_ONSITE_SDK?.showForm(feedbackFormID)
      }
    }
    addAnalyticsProvideFeedback()
  }

  return (
    <div className={Style.Feedback}>
      <div>
        <p>{feedBackTitle}</p>
      </div>
      <button className="button" onClick={showFeedbackForm}>
        {feedbackButtonLabel}
      </button>
    </div>
  )
}

export default Feedback
